import { render, staticRenderFns } from "./account-view.vue?vue&type=template&id=205ec3dc&"
import script from "./account-view.vue?vue&type=script&lang=js&"
export * from "./account-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports